import { render, staticRenderFns } from "./ReviewsFaq.vue?vue&type=template&id=60c2d93a"
import script from "./ReviewsFaq.vue?vue&type=script&lang=js"
export * from "./ReviewsFaq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports